module.exports = __webpack_public_path__ + "img/informatik_title_image.ca285ce4.jpg";